// extracted by css-extract-rspack-plugin
export default {"form_historical_date":"veW5JnWSIcYk8npQ","text":"L_uZ3UeGOEAhDX3Q","date_picker":"QZRxP_CndyMjpM40"};